
        import 'CaptureAdminEmail.13161b3.css-module'
        export default {"header":"header_CaptureAdminEmail_13161b3"}
    